import type { Alert } from "../data/api-types";
import { mockToday as today } from "./today";

function customerRef(id: string, name: string) {
  return { id, name, type: "customer", _self: `/customers/${id}` };
}

export const mockAlert: Alert = {
  _self: "/views/alerts/alert_001",
  type: "alert",
  customer: customerRef("cust_012", "Bramley & Co"),
  id: "alert_001",
  alert_id: "alert_001",
  customer_id: "cust_012",
  alert_definition_id: "alertdef_at_risk",
  alert_family: "risk",
  alert_name: "At Risk - Order Delay",
  title: "Bramley & Co order cadence has slipped",
  description: "Customer has not ordered in the expected window. Investigate.",
  severity: "high",
  status: "open",
  lifecycle_status: "open",
  created_at: `${today}T08:00:00Z`,
  signal_id: "sig_001",
  segment_id: "strategic",
  work_category_id: "",
  dismissed_at: null,
  converted_to_task_id: null,
};

export const mockAlerts: Alert[] = [
  mockAlert,
  {
    _self: "/views/alerts/alert_002",
    type: "alert",
    customer: customerRef("cust_048", "Business School UK"),
    id: "alert_002",
    alert_id: "alert_002",
    customer_id: "cust_048",
    alert_definition_id: "alertdef_growth_opportunity",
    alert_family: "opportunity",
    alert_name: "Growth Opportunity",
    title: "Business School UK could expand into packaging",
    description:
      "Adjacent work category showing demand from similar customers.",
    severity: "medium",
    status: "open",
    lifecycle_status: "open",
    created_at: `${today}T08:00:00Z`,
    signal_id: "sig_003",
    segment_id: "strategic",
    work_category_id: "",
    dismissed_at: null,
    converted_to_task_id: null,
  },
  {
    _self: "/views/alerts/alert_003",
    type: "alert",
    customer: customerRef("cust_073", "Henderson Group"),
    id: "alert_003",
    alert_id: "alert_003",
    customer_id: "cust_073",
    alert_definition_id: "alertdef_at_risk",
    alert_family: "risk",
    alert_name: "At Risk - No Recent Orders",
    title: "Henderson Group has not ordered in 27 days",
    description: "Customer cadence has dropped below threshold.",
    severity: "critical",
    status: "open",
    lifecycle_status: "open",
    created_at: `${today}T08:00:00Z`,
    signal_id: "sig_004",
    segment_id: "client",
    work_category_id: "",
    dismissed_at: null,
    converted_to_task_id: null,
  },
  {
    _self: "/views/alerts/alert_004",
    type: "alert",
    customer: customerRef("cust_022", "TechStart"),
    id: "alert_004",
    alert_id: "alert_004",
    customer_id: "cust_022",
    alert_definition_id: "alertdef_engagement_growth",
    alert_family: "growth",
    alert_name: "Strong Growth",
    title: "TechStart revenue up 24% over previous quarter",
    description: "Sustained growth pattern; consider account expansion.",
    severity: "low",
    status: "open",
    lifecycle_status: "open",
    created_at: `${today}T08:00:00Z`,
    signal_id: "sig_002",
    segment_id: "key",
    work_category_id: "",
    dismissed_at: null,
    converted_to_task_id: null,
  },
  {
    _self: "/views/alerts/alert_005",
    type: "alert",
    customer: customerRef("cust_048", "Business School UK"),
    id: "alert_005",
    alert_id: "alert_005",
    customer_id: "cust_048",
    alert_definition_id: "alertdef_seasonal_order_surge",
    alert_family: "opportunity",
    alert_name: "Seasonal order surge approaching",
    title: "Customer's seasonal order surge is approaching",
    description:
      "This customer reliably places a big order in September each year — that's 21 days away. Get ahead of it with a proactive check-in.",
    severity: "medium",
    status: "open",
    lifecycle_status: "open",
    created_at: `${today}T08:00:00Z`,
    signal_id: "sig_005",
    segment_id: "strategic",
    work_category_id: "",
    dismissed_at: null,
    converted_to_task_id: null,
  },
];
